import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TravellerFormComponent } from '../traveller-form/traveller-form.component';

@Component({
  selector: 'app-traveller-details',
  templateUrl: './traveller-details.component.html',
  styleUrls: ['./traveller-details.component.scss']
})
export class TravellerDetailsComponent implements OnInit {
  constructor( public dialog: MatDialog) { }

  isShow;

  ngOnInit(): void {
  }

  onManual(){
    this.dialog.open(TravellerFormComponent,{
      // width:'700px',
      // height:'120px',
    })
  }
  hide(){
    this.isShow = !this.isShow; 
  }

}
